/* Formulario de reseña. Tres entradas:
   /pages/resena?t=TOKEN        enlace de WhatsApp: productos del pedido, sin pedir celular.
   /pages/resena?producto=handle sin token: pide nombre y celular.
   Dentro de la ficha: assets/lenz-review-write.js llama a
     window.LenzReviewForm.mount(nodo, { product: {id,title,image}, embedded: true, onClose })
   y el formulario se abre en una ventana sobre la misma página.
   API en data-api del nodo (REVIEWS_API_CONTRACT.md). */
(function () {
  'use strict';
  function mount(root, opts) {
  opts = opts || {};
  var app = root.querySelector('[data-rform-app]');
  var API = (root.getAttribute('data-api') || '').replace(/\/+$/, '');
  var WA = root.getAttribute('data-wa') || '';
  var PRIVACY = root.getAttribute('data-privacy') || '/policies/privacy-policy';
  var EMBED = !!opts.embedded;
  var qs = new URLSearchParams(location.search);
  var TOKEN = EMBED ? null : qs.get('t');
  var HANDLE = EMBED ? null : qs.get('producto');
  var STARTED = Date.now();
  var UID = 'rf' + Math.random().toString(36).slice(2, 7);
  var MAX_PHOTOS = 5, MAX_PX = 2048;
  var LABELS = ['', 'Mala', 'Regular', 'Buena', 'Muy buena', 'Excelente'];
  var S = { items: [], name: '', google: '', edit: false, choose: false, sending: false, greet: '' };
  var queue = [], running = false, trap, nameIn, phoneIn, consentIn, msgBox, submitBtn;

  /* ── utilidades ── */
  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      var v = attrs[k];
      if (v == null || v === false) return;
      if (k === 'class') n.className = v;
      else if (k === 'text') n.textContent = v;
      else if (k.slice(0, 2) === 'on') n.addEventListener(k.slice(2), v);
      else n.setAttribute(k, v === true ? '' : v);
    });
    (kids || []).forEach(function (c) { if (c != null) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }
  function show(node) { app.innerHTML = ''; app.appendChild(node); }
  function api(method, path, body) {
    return fetch(API + path, {
      method: method,
      headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, json: j || {} }; });
    });
  }
  function waLink(text) { return WA + (WA.indexOf('?') > -1 ? '&' : '?') + 'text=' + encodeURIComponent(text); }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase(); }
  function publicName(full) {
    var w = String(full || '').trim().split(/\s+/).filter(Boolean);
    if (!w.length) return '';
    if (w.length === 1) return cap(w[0]);
    return cap(w[0]) + ' ' + w[w.length - 1].charAt(0).toUpperCase() + '.';
  }
  function phoneNorm(v) {
    var d = String(v || '').replace(/\D/g, '');
    if (d.length === 11 && d.slice(0, 2) === '51') d = d.slice(2);
    return /^9\d{8}$/.test(d) ? d : '';
  }

  /* ── pantallas ── */
  function box(title, text, actions) {
    return el('div', { class: 'lenz-rform__box', role: 'status' }, [
      el('h2', { text: title }), el('p', { text: text }),
      el('div', {}, actions || [])
    ]);
  }
  function errorScreen(kind) {
    var expired = kind === 'expired';
    var msg = expired ? 'Hola, mi enlace para dejar la reseña venció. ¿Me envían uno nuevo?' : 'Hola, tengo un problema con el enlace para dejar mi reseña.';
    show(box(expired ? 'Este enlace ya venció' : 'Este enlace no es válido',
      expired ? 'Los enlaces duran un tiempo limitado. Escríbenos por WhatsApp y te enviamos uno nuevo.'
        : 'Puede que esté incompleto. Revisa que hayas abierto el enlace completo del mensaje o escríbenos por WhatsApp y te ayudamos.',
      [el('a', { class: 'lenz-rform__link lenz-rform__link--wa', href: waLink(msg), target: '_blank', rel: 'noopener', text: 'Escribir por WhatsApp' })]));
  }
  function retryScreen(fn) {
    show(box('No pudimos conectarnos', 'Revisa tu conexión a internet e inténtalo otra vez.',
      [el('button', { type: 'button', class: 'lenz-rform__link', onclick: fn, text: 'Reintentar' })]));
  }
  function loading() { show(el('p', { class: 'lenz-rform__loading', text: 'Cargando…' })); }

  /* ── carga ── */
  function loadToken() {
    loading();
    api('GET', '/api/reviews/request/' + encodeURIComponent(TOKEN)).then(function (r) {
      if (r.status === 410) return errorScreen('expired');
      // 404 (token inexistente) y cualquier otro 4xx salvo 429: enlace no válido; 5xx/429/red: reintentar.
      if (r.status >= 400 && r.status < 500 && r.status !== 429) return errorScreen('invalid');
      if (r.status !== 200) return retryScreen(loadToken);
      var d = r.json;
      S.google = d.google_review_url || '';
      S.name = d.display_name || d.first_name || '';
      S.greet = d.first_name || '';
      S.items = (d.products || []).map(function (p) {
        var rv = p.reviewed && p.review ? p.review : null;
        if (rv) { S.edit = true; if (rv.name) S.name = rv.name; }
        return {
          product_id: String(p.product_id), title: p.title, image: p.image,
          rating: rv ? rv.rating : 0, body: rv ? rv.body : '',
          photos: rv ? (rv.photos || []).map(function (f) { return { media_id: f.media_id, url: f.url, status: 'done', pct: 100 }; }) : []
        };
      });
      // Reseñas ya hechas con este enlace, por producto: el buscador las vuelve a cargar.
      S.known = {};
      S.items.forEach(function (it) { if (it.rating) S.known[it.product_id] = it; });
      if (d.needs_product_choice) {
        // Sin pedido: si ya reseñó algo, entra directo a editarlo ("Pedir actualización").
        S.choose = true;
        S.items = S.items.filter(function (it) { return it.rating; });
        if (S.items.length) showForm(); else showChooser();
      } else if (!S.items.length) { S.choose = true; showChooser(); } else showForm();
    }).catch(function () { retryScreen(loadToken); });
  }
  function loadProduct() {
    loading();
    fetch('/products/' + encodeURIComponent(HANDLE) + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      if (r.status === 404) { showChooser('No encontramos ese producto. Búscalo aquí:'); return null; }
      if (!r.ok) throw new Error('http');
      return r.json();
    }).then(function (p) {
      if (!p) return;
      S.items = [{ product_id: String(p.id), title: p.title, image: p.featured_image || '', rating: 0, body: '', photos: [] }];
      showForm();
    }).catch(function () { retryScreen(loadProduct); });
  }

  /* ── buscador de productos ── */
  function showChooser(note) {
    var input = el('input', { type: 'search', id: 'lenz-rform-q', autocomplete: 'off', placeholder: 'Ej. Canon EOS R100' });
    var results = el('ul', { class: 'lenz-rform__results', hidden: true });
    var info = el('p', { class: 'lenz-rform__preview', role: 'status' });
    var timer, seq = 0;
    function find() {
      var q = input.value.trim(), my = ++seq;
      results.innerHTML = ''; results.hidden = true; info.textContent = '';
      if (q.length < 2) return;
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('http'); return r.json(); })
        .then(function (j) {
          if (my !== seq) return;
          var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
          if (!ps.length) { info.textContent = 'No encontramos productos con ese nombre.'; return; }
          ps.forEach(function (p) {
            var img = p.image || (p.featured_image && p.featured_image.url) || '';
            results.appendChild(el('li', {}, [el('button', {
              type: 'button', onclick: function () {
                var prev = S.known && S.known[String(p.id)];
                S.items = [prev || { product_id: String(p.id), title: p.title, image: img, rating: 0, body: '', photos: [] }];
                showForm();
              }
            }, [img ? el('img', { src: img, alt: '', width: 44, height: 44 }) : null, el('span', { text: p.title })])]));
          });
          results.hidden = false;
        }).catch(function () { if (my === seq) info.textContent = 'No pudimos buscar ahora. Inténtalo de nuevo.'; });
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(find, 250); });
    show(el('div', {}, [
      el('p', { class: 'lenz-rform__lead', text: note || (S.greet ? 'Hola, ' + S.greet + '. ' : '') + '¿Sobre qué producto quieres dejar tu reseña?' }),
      el('label', { class: 'lenz-rform__label', for: 'lenz-rform-q', text: 'Busca el producto' }),
      input, info, results
    ]));
  }

  /* ── fotos ── */
  function decode(file) {
    function viaImg() {
      return new Promise(function (res, rej) {
        var u = URL.createObjectURL(file), im = new Image();
        im.onload = function () { URL.revokeObjectURL(u); res(im); };
        im.onerror = function () { URL.revokeObjectURL(u); rej(new Error('decode')); };
        im.src = u;
      });
    }
    if (window.createImageBitmap) {
      return createImageBitmap(file, { imageOrientation: 'from-image' }).catch(viaImg);
    }
    return viaImg();
  }
  function shrink(file) {
    return decode(file).then(function (src) {
      var w = src.width || src.naturalWidth, h = src.height || src.naturalHeight;
      var k = Math.min(1, MAX_PX / Math.max(w, h));
      var c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(w * k)); c.height = Math.max(1, Math.round(h * k));
      var g = c.getContext('2d');
      g.fillStyle = '#fff'; g.fillRect(0, 0, c.width, c.height);
      g.drawImage(src, 0, 0, c.width, c.height);
      if (src.close) src.close();
      return new Promise(function (res, rej) {
        c.toBlob(function (b) { b ? res(b) : rej(new Error('blob')); }, 'image/jpeg', 0.85);
      });
    });
  }
  function toBase64(blob) {
    return new Promise(function (res, rej) {
      var fr = new FileReader();
      fr.onload = function () { res(String(fr.result).split(',')[1] || ''); };
      fr.onerror = function () { rej(new Error('read')); };
      fr.readAsDataURL(blob);
    });
  }
  function mediaError(status, j) {
    if (j && j.error === 'too_large') return 'Pesa demasiado';
    if (j && j.error === 'invalid_image') return 'Foto no válida';
    if (status === 429) return 'Espera y reintenta';
    return 'No se subió';
  }
  function upload(p) {
    return new Promise(function (res, rej) {
      var x = new XMLHttpRequest();
      x.open('POST', API + '/api/reviews/media');
      x.setRequestHeader('Content-Type', 'application/json');
      x.upload.onprogress = function (e) {
        if (e.lengthComputable && p.bar) { p.pct = Math.round(e.loaded / e.total * 100); p.bar.style.width = p.pct + '%'; }
      };
      x.onload = function () {
        var j = {};
        try { j = JSON.parse(x.responseText); } catch (_) { /* sin cuerpo */ }
        if (x.status === 201 && j.media_id) { p.media_id = j.media_id; p.status = 'done'; p.pct = 100; res(); }
        else rej({ msg: mediaError(x.status, j), retry: x.status === 429 || x.status >= 500 || x.status === 0 });
      };
      x.onerror = function () { rej({ msg: 'Sin conexión', retry: true }); };
      x.send(JSON.stringify({ token: TOKEN || undefined, data_base64: p.b64, filename: (p.file.name || 'foto').replace(/\.[^.]+$/, '') + '.jpg' }));
    });
  }
  function process(p) {
    p.status = 'working'; p.msg = '';
    var step = p.b64 ? Promise.resolve() : shrink(p.file).then(function (blob) {
      p.preview = URL.createObjectURL(blob);
      return toBase64(blob).then(function (b) { p.b64 = b; });
    }).catch(function () { throw { msg: 'No se pudo leer', retry: false }; });
    paintPhotos(p.it);
    return step.then(function () { return upload(p); }).catch(function (e) {
      p.status = 'error'; p.msg = (e && e.msg) || 'No se subió'; p.retry = !!(e && e.retry);
    });
  }
  function pump() {
    if (running) return;
    var p = queue.shift();
    while (p && p.removed) p = queue.shift();
    if (!p) return updateSubmit();
    running = true;
    process(p).then(function () { running = false; paintPhotos(p.it); pump(); });
  }
  function addFiles(it, files) {
    var list = Array.prototype.slice.call(files), room = MAX_PHOTOS - it.photos.length;
    if (list.length > room) it.ui.photoErr.textContent = 'Puedes subir hasta ' + MAX_PHOTOS + ' fotos.'; else it.ui.photoErr.textContent = '';
    list.slice(0, Math.max(0, room)).forEach(function (f) {
      var p = { file: f, status: 'queued', pct: 0, it: it };
      it.photos.push(p); queue.push(p);
    });
    paintPhotos(it); pump(); updateSubmit();
  }
  function paintPhotos(it) {
    var ul = it.ui.thumbs;
    ul.innerHTML = '';
    it.photos.forEach(function (p, i) {
      var busy = p.status === 'queued' || p.status === 'working';
      var li = el('li', { class: 'lenz-rform__thumb' + (p.status === 'error' ? ' is-bad' : '') });
      var src = p.preview || p.url;
      if (src) li.appendChild(el('img', { src: src, alt: 'Foto ' + (i + 1) }));
      li.appendChild(el('button', {
        type: 'button', 'aria-label': 'Quitar foto ' + (i + 1), text: '×', onclick: function () {
          p.removed = true; if (p.preview) URL.revokeObjectURL(p.preview);
          it.photos.splice(it.photos.indexOf(p), 1); paintPhotos(it); updateSubmit();
        }
      }));
      if (busy) {
        p.bar = el('i'); p.bar.style.width = p.pct + '%';
        li.appendChild(el('span', { class: 'lenz-rform__prog', role: 'progressbar', 'aria-label': 'Subiendo foto ' + (i + 1) }, [p.bar]));
      }
      if (p.status === 'error') {
        li.appendChild(el('span', { class: 'lenz-rform__thumb-msg', text: p.msg }));
        if (p.retry) li.appendChild(el('button', {
          type: 'button', 'aria-label': 'Reintentar foto ' + (i + 1), text: '↻', style: 'left:2px;right:auto',
          onclick: function () { p.status = 'queued'; queue.push(p); paintPhotos(it); pump(); }
        }));
      }
      ul.appendChild(li);
    });
    it.ui.add.hidden = it.photos.length >= MAX_PHOTOS;
    it.ui.add.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" d="M4 8h3l1.6-2.2h6.8L17 8h3v11H4z"/><circle cx="12" cy="13.2" r="3.4" fill="none" stroke="currentColor" stroke-width="1.8"/></svg><span></span>';
    it.ui.add.lastChild.textContent = it.photos.length ? 'Agregar (' + it.photos.length + '/' + MAX_PHOTOS + ')' : 'Agregar fotos';
    it.ui.add.setAttribute('aria-label', it.photos.length ? 'Agregar otra foto, ' + it.photos.length + ' de ' + MAX_PHOTOS : 'Agregar fotos, hasta ' + MAX_PHOTOS);
  }
  function uploading() {
    return S.items.some(function (it) { return it.photos.some(function (p) { return p.status === 'queued' || p.status === 'working'; }); });
  }
  function updateSubmit() {
    if (!submitBtn || S.sending) return;
    var u = uploading();
    submitBtn.disabled = u;
    submitBtn.textContent = u ? 'Subiendo fotos…' : (S.edit ? 'Guardar cambios' : 'Enviar reseña');
  }

  /* ── formulario ── */
  function itemBlock(it, i) {
    var ui = it.ui = {};
    var radios = [], labels = [];
    function paint(v) { labels.forEach(function (l, k) { l.classList.toggle('is-on', k < v); }); ui.word.textContent = LABELS[v] || ''; }
    ui.stars = el('div', { class: 'lenz-rform__stars' });
    for (var s = 1; s <= 5; s++) (function (n) {
      var r = el('input', { type: 'radio', name: 'rating-' + i, value: n, 'aria-label': n + (n === 1 ? ' estrella' : ' estrellas') });
      r.checked = it.rating === n;
      r.addEventListener('change', function () { it.rating = n; ui.err.rating.textContent = ''; paint(n); });
      var ico = el('span', { 'aria-hidden': 'true' });
      ico.innerHTML = '<svg viewBox="0 0 24 24" width="36" height="36" focusable="false"><path d="M12 2.6l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5L12 17.4l-5.8 3.1 1.1-6.5L2.6 9.4l6.5-.9z"/></svg>';
      var lab = el('label', { class: 'lenz-rform__star' }, [r, ico]);
      lab.addEventListener('mouseenter', function () { paint(n); });
      lab.addEventListener('mouseleave', function () { paint(it.rating); });
      radios.push(r); labels.push(lab); ui.stars.appendChild(lab);
    })(s);
    ui.word = el('span', { class: 'lenz-rform__stars-text', 'aria-hidden': 'true' });
    ui.stars.appendChild(ui.word);
    ui.radios = radios;
    ui.err = { rating: el('p', { class: 'lenz-rform__err', role: 'alert' }), body: el('p', { class: 'lenz-rform__err', role: 'alert' }) };
    paint(it.rating);

    var ta = el('textarea', { id: UID + '-body-' + i, rows: 5, maxlength: 2000, 'aria-describedby': UID + '-cnt-' + i, placeholder: 'Cuéntanos qué te pareció: calidad, entrega, atención…' });
    ta.value = it.body;
    var cnt = el('p', { class: 'lenz-rform__counter', id: UID + '-cnt-' + i });
    function count() { it.body = ta.value; var n = ta.value.trim().length; cnt.textContent = n < 10 ? n + '/2000 · mínimo 10 caracteres' : n + '/2000'; if (n >= 10) ui.err.body.textContent = ''; }
    ta.addEventListener('input', count); ui.ta = ta; count();

    ui.thumbs = el('ul', { class: 'lenz-rform__thumbs', 'aria-label': 'Fotos de tu reseña' });
    ui.photoErr = el('p', { class: 'lenz-rform__err', role: 'alert' });
    var file = el('input', { type: 'file', accept: 'image/*', multiple: true, hidden: true });
    file.addEventListener('change', function () { addFiles(it, file.files); file.value = ''; });
    ui.add = el('button', { type: 'button', class: 'lenz-rform__add', onclick: function () { file.click(); } });

    var prod = el('div', { class: 'lenz-rform__product' }, [
      it.image ? el('img', { src: it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160', alt: '', width: 64, height: 64 }) : null,
      el('strong', { text: it.title })
    ]);
    if (S.choose) prod.appendChild(el('button', { type: 'button', class: 'lenz-rform__link lenz-rform__link--ghost', style: 'min-height:36px;padding:0 12px;font-size:13px;margin-left:auto', onclick: function () { S.items = []; showChooser(); }, text: 'Cambiar' }));
    var fs = el('fieldset', { class: 'lenz-rform__item', style: 'min-width:0', 'aria-label': it.title }, [
      prod,
      el('div', {}, [el('p', { class: 'lenz-rform__label', style: 'margin-top:0', id: UID + '-r-' + i, text: 'Tu calificación' }), ui.stars, ui.err.rating]),
      el('label', { class: 'lenz-rform__label', for: UID + '-body-' + i }, ['Tu reseña ', el('span', { class: 'lenz-rform__hint', text: '(10 a 2000 caracteres)' })]),
      ta, cnt, ui.err.body,
      el('p', { class: 'lenz-rform__label' }, ['Fotos ', el('span', { class: 'lenz-rform__hint', text: '(opcional, hasta ' + MAX_PHOTOS + ')' })]),
      el('div', { class: 'lenz-rform__photos' }, [ui.thumbs, ui.add]), file, ui.photoErr
    ]);
    ui.stars.setAttribute('role', 'radiogroup'); ui.stars.setAttribute('aria-labelledby', UID + '-r-' + i);
    paintPhotos(it);
    return fs;
  }

  function showForm() {
    var web = !TOKEN;
    var form = el('form', { novalidate: true, onsubmit: submit });
    var lead = EMBED ? 'Tu opinión ayuda a otras personas a elegir. La revisamos antes de publicarla.'
      : web ? 'Cuéntanos qué te pareció. Revisaremos tu reseña antes de publicarla.'
      : (S.greet ? 'Hola, ' + S.greet + '. ' : '') + (S.edit ? 'Ya nos dejaste una reseña. Puedes editarla aquí.' : 'Cuéntanos qué te pareció tu compra. Tu opinión ayuda a otras personas.');
    form.appendChild(el('p', { class: 'lenz-rform__lead', text: lead }));
    S.items.forEach(function (it, i) { form.appendChild(itemBlock(it, i)); });

    var errs = S.err = { name: el('p', { class: 'lenz-rform__err', role: 'alert' }), phone: el('p', { class: 'lenz-rform__err', role: 'alert' }), consent: el('p', { class: 'lenz-rform__err', role: 'alert' }) };
    nameIn = el('input', { type: 'text', id: UID + '-name', autocomplete: 'name', maxlength: 60 });
    nameIn.value = S.name;
    var preview = el('p', { class: 'lenz-rform__preview', 'aria-live': 'polite' });
    function pv() { var n = publicName(nameIn.value); preview.textContent = n ? 'Se publicará como ' + n : ''; if (nameIn.value.trim().length >= 2) errs.name.textContent = ''; }
    nameIn.addEventListener('input', pv); pv();
    // Nombre y celular en dos columnas (.lenz-rform__who); la ayuda va debajo
    // de cada campo para que las etiquetas queden alineadas.
    var nameCol = el('div', { class: 'lenz-rform__field' }, [
      el('label', { class: 'lenz-rform__label', for: UID + '-name' }, ['Tu nombre ', web ? null : el('span', { class: 'lenz-rform__hint', text: '(puedes cambiarlo)' })]),
      nameIn, preview, errs.name
    ]);
    var who = el('div', { class: 'lenz-rform__item lenz-rform__who' }, [nameCol]);
    if (web) {
      phoneIn = el('input', { type: 'tel', id: UID + '-phone', inputmode: 'tel', autocomplete: 'tel-national', maxlength: 20, placeholder: '987 654 321', 'aria-describedby': UID + '-phone-hint' });
      phoneIn.addEventListener('input', function () { errs.phone.textContent = ''; });
      who.appendChild(el('div', { class: 'lenz-rform__field' }, [
        el('label', { class: 'lenz-rform__label', for: UID + '-phone' }, ['Tu celular']),
        phoneIn,
        el('p', { class: 'lenz-rform__preview', id: UID + '-phone-hint', text: 'No se publica. Nos ayuda a confirmar tu compra.' }),
        errs.phone
      ]));
    } else phoneIn = null;
    form.appendChild(who);

    trap = el('input', { type: 'text', name: 'website', tabindex: '-1', autocomplete: 'off', 'aria-hidden': 'true' });
    form.appendChild(el('div', { class: 'lenz-rform__trap', 'aria-hidden': 'true' }, [el('label', { text: 'Sitio web' }), trap]));

    consentIn = el('input', { type: 'checkbox', id: UID + '-consent' });
    consentIn.addEventListener('change', function () { errs.consent.textContent = ''; });
    form.appendChild(el('label', { class: 'lenz-rform__consent', for: UID + '-consent' }, [consentIn, el('span', {}, [
      'Acepto que Lenz publique mi reseña, mi nombre como se muestra y mis fotos en lenz.pe. ',
      el('a', { href: PRIVACY, target: '_blank', rel: 'noopener', text: 'Política de privacidad' })
    ])]));
    form.appendChild(errs.consent);

    msgBox = el('p', { class: 'lenz-rform__msg', role: 'alert', hidden: true });
    submitBtn = el('button', { type: 'submit', class: 'lenz-rform__submit' });
    form.appendChild(msgBox); form.appendChild(submitBtn);
    show(form); updateSubmit();
  }

  function say(t) { msgBox.textContent = t || ''; msgBox.hidden = !t; if (t) msgBox.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
  function focusFirst(node) { if (node) { node.scrollIntoView({ block: 'center', behavior: 'smooth' }); node.focus({ preventScroll: true }); } }

  function validate() {
    var first = null, ok = true;
    function bad(p, text, node) { p.textContent = text; ok = false; if (!first) first = node; }
    var multi = S.items.length > 1;
    var chosen = S.items.filter(function (it) { return !multi || it.rating || it.body.trim() || it.photos.length; });
    if (!chosen.length) { say('Cuéntanos al menos sobre uno de los productos.'); return null; }
    chosen.forEach(function (it) {
      it.ui.err.rating.textContent = ''; it.ui.err.body.textContent = '';
      if (!it.rating) bad(it.ui.err.rating, 'Elige de 1 a 5 estrellas.', it.ui.radios[0]);
      var n = it.body.trim().length;
      if (n < 10) bad(it.ui.err.body, 'Escribe al menos 10 caracteres.', it.ui.ta);
      else if (n > 2000) bad(it.ui.err.body, 'El máximo es 2000 caracteres.', it.ui.ta);
    });
    var nm = nameIn.value.trim();
    if ((!TOKEN && nm.length < 2) || (nm && nm.length < 2) || nm.length > 60) bad(S.err.name, 'Escribe tu nombre (de 2 a 60 caracteres).', nameIn);
    if (phoneIn && !phoneNorm(phoneIn.value)) bad(S.err.phone, 'Escribe un celular peruano de 9 dígitos, por ejemplo 987654321.', phoneIn);
    if (!consentIn.checked) bad(S.err.consent, 'Necesitamos tu autorización para publicar la reseña.', consentIn);
    if (ok) {
      var broken = chosen.some(function (it) { return it.photos.some(function (p) { return p.status === 'error'; }); });
      if (broken) { say('Hay fotos que no se subieron. Quítalas o reintenta con el botón ↻.'); return null; }
    }
    if (!ok) { focusFirst(first); return null; }
    return chosen;
  }

  function fieldErrors(it, fields) {
    var known = false;
    Object.keys(fields || {}).forEach(function (k) {
      var t = 'Revisa este dato.';
      if (k === 'rating') it.ui.err.rating.textContent = t; else if (k === 'body') it.ui.err.body.textContent = 'Revisa el texto: de 10 a 2000 caracteres.';
      else if (k === 'name') S.err.name.textContent = 'Revisa tu nombre.'; else if (k === 'phone' && S.err.phone) S.err.phone.textContent = 'Revisa tu celular.';
      else if (k === 'consent') S.err.consent.textContent = 'Necesitamos tu autorización.'; else return;
      known = true;
    });
    say(known ? 'Revisa los campos marcados.' : 'No pudimos guardar tu reseña. Revisa los datos e inténtalo otra vez.');
  }

  function submit(e) {
    e.preventDefault();
    if (S.sending || uploading()) return;
    say('');
    var chosen = validate();
    if (!chosen) return;
    S.sending = true; submitBtn.disabled = true; submitBtn.textContent = 'Enviando…';
    var results = [], nm = nameIn.value.trim();
    function end(msg) { S.sending = false; updateSubmit(); if (msg) say(msg); }
    (function next(i) {
      if (i >= chosen.length) return thanks(results);
      var it = chosen[i];
      if (it.sent) { results.push(it.sent); return next(i + 1); }
      api('POST', '/api/reviews', {
        token: TOKEN || undefined, product_id: it.product_id, rating: it.rating, body: it.body.trim(),
        name: nm || undefined, phone: phoneIn ? phoneNorm(phoneIn.value) : undefined, consent: true,
        media_ids: it.photos.filter(function (p) { return p.status === 'done' && p.media_id; }).map(function (p) { return p.media_id; }),
        website: trap.value, started_at: STARTED
      }).then(function (r) {
        if (r.status === 201) { it.sent = r.json; results.push(r.json); return next(i + 1); }
        if (r.status === 404 && TOKEN) return errorScreen('invalid');
        if (r.status === 410) return errorScreen('expired');
        if (r.status === 400) { fieldErrors(it, r.json.fields); return end(); }
        if (r.status === 429) return end('Hiciste varios intentos seguidos. Espera unos minutos e inténtalo otra vez.');
        if (r.status === 503) return end('Por ahora no estamos recibiendo reseñas. Inténtalo más tarde o escríbenos por WhatsApp.');
        end('No pudimos guardar tu reseña. Inténtalo otra vez en un momento.');
      }).catch(function () { end('No pudimos enviar tu reseña. Revisa tu conexión y vuelve a intentarlo.'); });
    })(0);
  }

  function thanks(results) {
    var published = results.some(function (r) { return r.status === 'published'; });
    var url = S.google;
    results.forEach(function (r) { if (r.google_review_url) url = r.google_review_url; });
    var title, text;
    if (!TOKEN) { title = 'Gracias, la revisaremos antes de publicarla'; text = 'Cuando esté lista aparecerá en la ficha del producto.'; }
    else if (published) { title = S.edit ? '¡Listo, actualizamos tu reseña!' : '¡Gracias por tu reseña!'; text = 'Ya está publicada en lenz.pe. Tu opinión ayuda a otras personas a elegir mejor.'; }
    else { title = 'Gracias, la revisaremos antes de publicarla'; text = 'Cuando esté lista aparecerá en la ficha del producto.'; }
    var actions = [];
    if (url) actions.push(el('a', { class: 'lenz-rform__link', href: url, target: '_blank', rel: 'noopener', text: 'Déjanos también una reseña en Google' }));
    actions.push(el('p', {}, [EMBED
      ? el('button', { type: 'button', class: 'lenz-rform__link lenz-rform__link--ghost', onclick: function () { if (opts.onClose) opts.onClose(); }, text: 'Cerrar' })
      : el('a', { class: 'lenz-rform__link lenz-rform__link--ghost', href: '/', text: 'Volver a la tienda' })]));
    actions[actions.length - 1].style.marginTop = '12px';
    show(box(title, text, actions));
    if (EMBED) { if (root.scrollTo) root.scrollTo({ top: 0, behavior: 'smooth' }); }
    else window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  if (opts.product) {
    var pr = opts.product;
    S.items = [{ product_id: String(pr.id), title: pr.title, image: pr.image || '', rating: Number(opts.rating) || 0, body: '', photos: [] }];
    showForm();
  } else if (TOKEN) loadToken();
  else if (HANDLE) loadProduct();
  else showChooser();
  }

  window.LenzReviewForm = { mount: mount };
  var page = document.getElementById('lenz-review-form');
  if (page) mount(page);
})();
